import React, { ChangeEvent, ReactElement, useState } from 'react'
import { useSelector } from 'react-redux'
import { IStepProps } from '../../interfaces/Step'
import {
  DOCUMENT_TYPE_UPLOAD_FILES_FOR_STEPS,
  FILE_STATUS,
  OTHER_SELECT_INDEX,
  STATUS,
  STEP1_IDENTITY_UPLOAD_FILES,
} from '../../enums/common'
import Upload from '../upload/uploadWithRetry/Upload'
import useStep1FormHook from '../../hooks/Step1FormHook'
import { IDENTITY_DOCUMENT_TYPE } from '../../enums/Options'
import { getUploadCount, preventEnterFormSubmit } from '../../services/utils'
import OtherUpload from './OtherUpload'
import SubmitButton from '../SubmitButton'
import useUploadWithRetryHook from '../../hooks/UseUploadWithRetryHook'
import { deleteIcon } from '../../assets/images/images'
import Step1Modal from './Step1Modal'
import { IStore } from '../../interfaces/Store'
import Step1InfoText from './Step1InfoText'
import IdentityQuestion from './IdentityQuestion'
import IdentityInformations from './IdentityInformations'

const index = 0
function Step1FormPeriodicRemediation(props: IStepProps): ReactElement {
  const step1FormData = useStep1FormHook(props)
  const folder = useSelector(
    (stateReducer: IStore) => stateReducer.folderReducer.folder
  )

  const [displayOtherSelect, setDisplayOtherSelect] = useState('')

  const {
    identity_document_type,
    form,
    onSubmit,
    state,
    watchIdentityDocumentType,
    watchOtherDocumentType,
    handleNextStep,
    setState,
    validateFile,
    refreshDocumentsState,
    removeInvalidDocument,
  } = step1FormData

  const {
    file,
    fileAlerts,
    status,
    toggleValidateButton,
    validationButtonError,
  } = state[index]
  const {
    handleChange,
    uploadFile,
    getExistingFiles,
    removeFiles,
    shouldDisplayValidateDocuments,
  } = useUploadWithRetryHook({
    index,
    setState,
    mainState: state,
    validateFile,
    refreshDocumentsState,
    selectIndex: displayOtherSelect,
  })
  const { handleSubmit, register, errors, watch } = form

  const isMultifile =
    watchIdentityDocumentType &&
    STEP1_IDENTITY_UPLOAD_FILES[watchIdentityDocumentType] &&
    STEP1_IDENTITY_UPLOAD_FILES[watchIdentityDocumentType].length > 1
  const toggleDeleteButton =
    isMultifile &&
    state[index].canRetry[0] &&
    state[index].status !== STATUS.pending
  const handleSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target
    setDisplayOtherSelect(value === OTHER_SELECT_INDEX ? '-2' : '')
    setState((prevState) => {
      const indexPrevState = prevState[index]
      const newState = [...prevState]
      newState[index] = {
        ...indexPrevState,
        docValue: value,
      }
      return newState
    })
    if (value === OTHER_SELECT_INDEX || refreshDocumentsState) {
      return
    }
    handleChange(event)
  }

  const handleOtherSelectChange = async (
    event: ChangeEvent<HTMLSelectElement>
  ) => {
    if (refreshDocumentsState) {
      return
    }

    const { value } = event.target
    setState((prevState) => {
      const indexPrevState = prevState[index]
      const newState = [...prevState]
      if (indexPrevState.fileStatus[0] === FILE_STATUS.pending) {
        indexPrevState.file[0] = null
      }
      newState[index] = {
        ...indexPrevState,
        fileAlerts: [],
        docValue: value,
      }
      return newState
    })

    if (value === '') {
      setState((prevState) => {
        const indexPrevState = prevState[index]
        const newState = [...prevState]

        newState[index] = {
          ...indexPrevState,
          toggleValidateButton: false,
        }
        return newState
      })
      return
    }

    if (value !== undefined) {
      await getExistingFiles(
        DOCUMENT_TYPE_UPLOAD_FILES_FOR_STEPS['0-2'][value],
        true
      )
    }
  }
  const [existingIdentityChecked, setExistingIdentityChecked] = useState(
    folder.existing_identity
  )
  const onRadioChange = () => {
    const watchExistingIdentity = watch('existing_identity')
    setExistingIdentityChecked(watchExistingIdentity)
  }
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <form
      className="row"
      onSubmit={handleSubmit(onSubmit)}
      onKeyPress={preventEnterFormSubmit}
    >
      <div className="col12">
        <IdentityQuestion
          existing_identity={folder.existing_identity || ''}
          register={register}
          error={errors}
          onRadioChange={onRadioChange}
        />
        <IdentityInformations
          folder={folder}
          existingIdentity={existingIdentityChecked}
          register={register}
        />
      </div>

      {existingIdentityChecked === '0' && (
        <>
          <div className="colLg12">
            <div className="backgroundWarningInfo ml0 mt1 mb2 py1 px1">
              <p>
                Les données présentées ne correspondant pas à votre identité,
                nous vous invitons, ci-dessous, à nous transmettre un
                justificatif d'identité à jour
              </p>
            </div>
            <Step1InfoText />
          </div>
          <div className="colLg7">
            <div className="lh2 pt1md">
              <p>Veuillez nous transmettre un justificatif d’identité.</p>
              <p className="mb2">Le document doit être en cours de validité.</p>
            </div>
            <input type="hidden" name="action" ref={register} />
            <Upload
              onChange={handleSelectChange}
              options={IDENTITY_DOCUMENT_TYPE}
              value={identity_document_type}
              register={register({ required: true })}
              name="identity_document_type"
              id="identity_document_type"
              error={errors.identity_document_type}
              label="Justificatif d’identité"
              required
              uploadFilesTypes={STEP1_IDENTITY_UPLOAD_FILES}
              files={file}
              fileType={watchIdentityDocumentType}
              fileAlerts={fileAlerts}
              status={status}
              state={state}
              setState={setState}
              validateFile={validateFile}
              stateIndex={index}
              className="mb25 mb4md"
              isMultifile={isMultifile}
            />
            {watchIdentityDocumentType === '4' && (
              <OtherUpload
                handleChange={handleOtherSelectChange}
                register={register}
                errors={errors}
                files={file}
                watchOtherDocumentType={watchOtherDocumentType}
                fileAlerts={fileAlerts}
                status={status}
                state={state}
                setState={setState}
                validateFile={validateFile}
                stateIndex={index}
                isMultifile={isMultifile}
              />
            )}
            {(toggleValidateButton || toggleDeleteButton) && (
              <>
                <div className="pt35 pt0md dFlex justifyContentEnd flexWrap flexSmNowrap">
                  {toggleDeleteButton && +getUploadCount()! < 3 && (
                    <button
                      className={`btn btnOutline wFull wAutoSm px3sm py1sm dInlineFlex alignItemsCenter justifyContentCenter mb15 mb0sm py12 ${
                        toggleValidateButton ? 'mr15sm' : ''
                      }`}
                      type="button"
                      onClick={removeFiles}
                    >
                      <img className="mr15" src={deleteIcon} alt="delete" />
                      Supprimer les fichiers
                    </button>
                  )}

                  {toggleValidateButton && shouldDisplayValidateDocuments && (
                    <button
                      className="btn btnPrimary btnPrimaryMd wFull wAutoSm"
                      type="button"
                      onClick={(event) =>
                        removeInvalidDocument().then(() =>
                          uploadFile(event, true)
                        )
                      }
                    >
                      Valider les documents
                    </button>
                  )}
                </div>
                {toggleValidateButton &&
                  shouldDisplayValidateDocuments &&
                  validationButtonError && (
                    <p
                      className={`${validationButtonError.type}Error textRight mt1`}
                    >
                      {validationButtonError.message}
                    </p>
                  )}
              </>
            )}
          </div>
        </>
      )}
      <div className="col12 pt45 pt10md textRight">
        <SubmitButton
          className="px7sm"
          label="Étape suivante"
          onClick={handleNextStep}
        />
      </div>

      <Step1Modal {...step1FormData} />
    </form>
  )
}

export default Step1FormPeriodicRemediation
